import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSSeparator from 'designSystem/components/PDSSeparator/PDSSeparator'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  hideModal: () => void
  onClick: () => void
  showModal: boolean
  isConnectedAccount: boolean
}

export default function ConfirmDeletePortfolioModal({
  hideModal,
  onClick,
  showModal,
  isConnectedAccount,
}: Props) {
  return (
    <Modal isCentered isOpen={showModal} onClose={hideModal} size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <PDSBox>
            <PDSHeader variant="h4">Delete portfolio?</PDSHeader>
          </PDSBox>
        </ModalHeader>
        <ModalBody paddingBottom={SIZE.s16} paddingTop={SIZE.s0}>
          <PDSFlexBox flexDirection="column" gap={SIZE.s12}>
            <PDSText>
              Are you sure you want to delete this portfolio? Doing so will
              remove it from its group and delete the portfolio's performance,
              trade history, and investment preference data.
            </PDSText>
            {true && (
              <PDSText>
                The account connected to this portfolio can still be found
                within the connected accounts page. This action cannot be
                undone.
              </PDSText>
            )}
          </PDSFlexBox>
        </ModalBody>

        <PDSSeparator />

        <ModalFooter padding={SIZE.s32}>
          <PDSFlexBox flexDirection="column" gap={SIZE.s8} width="100%">
            <PDSButton
              onClick={onClick}
              size="md-f"
              text="Delete"
              variant="danger"
            />

            <PDSButton
              onClick={hideModal}
              size="md-f"
              text="Cancel"
              variant="secondary"
            />
          </PDSFlexBox>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
